import { initializeApp } from 'firebase/app';
import { getAnalytics } from 'firebase/analytics';
import { getAuth } from 'firebase/auth';
import { getFirestore, connectFirestoreEmulator } from 'firebase/firestore';
import { getStorage, connectStorageEmulator } from 'firebase/storage';
import { getFunctions, connectFunctionsEmulator } from 'firebase/functions';

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY || 'AIzaSyCV3xn-hD2oVYEWDRQE070IbC42jy17o0A',
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN || 'leisurebreakswebsite.firebaseapp.com',
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID || 'leisurebreakswebsite',
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET || 'leisurebreakswebsite.firebasestorage.app',
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID || '932744227306',
  appId: import.meta.env.VITE_FIREBASE_APP_ID || '1:932744227306:web:3b5e3a1e1d7c2e9f4f2a93',
  measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID || 'G-MND22S7595',
};

const app = initializeApp(firebaseConfig);

// Initialize Analytics (only in browser, not SSR)
let analytics;
if (typeof window !== 'undefined') {
  analytics = getAnalytics(app);
}

export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export const functions = getFunctions(app, 'us-central1');

// Connect to emulators in development
if (import.meta.env.VITE_USE_EMULATOR === 'true') {
  connectFirestoreEmulator(db, 'localhost', 8080);
  connectStorageEmulator(storage, 'localhost', 9199);
  connectFunctionsEmulator(functions, 'localhost', 5001);
}

export { analytics };
export default app;

